import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import LoadingSpinner from '../../components/UI/LoadingSpinner';

// Forgot-password: enter email -> server emails a reset link. The response is
// always generic (no account enumeration), so we show the same confirmation
// regardless of whether the email exists.
const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('/auth/forgot-password', { email });
    } catch (_) {
      // Intentionally ignore — response is generic either way.
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Reset your password</h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Enter your email and we'll send you a link to reset your password.
          </p>
        </div>

        {sent ? (
          <div className="bg-white rounded-lg shadow-sm p-6 text-center">
            <p className="text-gray-800 font-medium mb-2">Check your email</p>
            <p className="text-sm text-gray-600">
              If an account exists for <span className="font-medium">{email}</span>, a password reset link is on its way. The link expires in 30 minutes.
            </p>
            <Link to="/login" className="inline-block mt-4 font-medium text-blue-600 hover:text-blue-500">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="form-label">Email address</label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="you@example.com"
              />
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full flex justify-center">
              {loading ? <LoadingSpinner size="sm" /> : 'Send reset link'}
            </button>
            <p className="text-center text-sm text-gray-600">
              Remembered it?{' '}
              <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
